import React, { useContext, useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import {
	Grid,
	Typography,
	Paper,
	Button,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	AppBar,
	Tabs,
	Tab,
} from "@material-ui/core";

import { UserContext } from "../../contexts/UserContext";
import FileUploadField from "./FileUploadField";
import { stringToFilename } from "../../functions/GlobalHelpers";
import CreditFilesBawag from "./CreditFilesBawag";
import CreditFilesStart from "./CreditFilesStart";
import CreditFilesBankAustria from './CreditFilesBankAustria';


import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SyncIcon from '@material-ui/icons/Sync';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GetAppIcon from '@material-ui/icons/GetApp';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";


const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1000,
		marginLeft: "auto",
		marginRight: "auto"
	},
	descriptionPaper: theme.descriptionPaper,
	accordionDetailsWithTabs: {
		display: "block"
	},
	progress: theme.progress
}));

export default function CreditFiles(
	{
		credit,
		creditFunctions,
		metafields,
		setMetafields,
		channels,
		renderCreditField,
		channelDisplayNames
	}) {
	const theme = useTheme();
	const classes = useStyles();
	let history = useHistory();
	const userContext = useContext(UserContext);
	const [activeTabPerson, setActiveTabPerson] = useState(0);
	const [activeTabLiegenschaft, setActiveTabLiegenschaft] = useState(0);
	const [activeTabVorlast, setActiveTabVorlast] = useState(0);

	const [availableFiles, setAvailableFiles] = useState({});
	const [fileGroupsCompleted, setFileGroupsCompleted] = useState({});
	const previous_years = [new Date().getFullYear().toString()];
	for (let i = 0; i < 6; i++) {
		previous_years.push((previous_years[previous_years.length - 1] - 1).toString());
	}
	const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
	const previous_months = [];

	for (let i = -1; i < 12; i++) {
		let month = new Date().getMonth() - i;
		let year = new Date().getFullYear();
		if (month < 1) {
			month += 12;
			year--;
		}

		previous_months.push(year + ("0" + month).slice(-2));
	}
	const file_document_type_suggestions = {
		person: {
			ausweis: {
				label: "Ausweis",
				description: "Foto oder Scan eines amtlichen Lichtbildausweises"
			},
			kontoauszug: {
				label: "Kontoauszug",
				description: "pro Person getrennt, KEINE Screenshots, KEINE Excel-Dateien oder andere Aufstellungen"
			},
			lohnzettel: {
				label: "Lohnzettel",
				subfield:
				{
					key: "month",
					label: "Monat",
					options: [
						"mehrere",
						...previous_months
					]
				},
				description: "entweder pro Monat eine Datei oder mehrere gesammelt in einem."
			},
			ea: {
				label: "Einnahmen-Ausgaben Rechnung",
				subfield:
				{
					key: "year",
					label: "Jahr",
					options: previous_years
				},
				description: "jedes Jahr als eigene Datei"
			},
			bilanz: {
				label: "Bilanz",
				subfield:
				{
					key: "year",
					label: "Jahr",
					options: previous_years
				},
				description: "jedes Jahr als eigene Datei"
			},
			est_erklaerung: {
				label: "EST-Erklärung",
				subfield:
				{
					key: "year",
					label: "Jahr",
					options: previous_years
				}
				,
				description: "Einkommensteuererklärung, jedes Jahr als eigene Datei"
			},
			est_bescheid: {
				label: "EST-Bescheid",
				subfield:
				{
					key: "year",
					label: "Jahr",
					options: previous_years
				},
				description: "Einkommensteuerbescheid, jedes Jahr als eigene Datei"
			},
			saldenliste: {
				label: "Saldenliste",
			},
			bestaetigung_sv: {
				label: "Bestätigung Sozialversicherung"
			},
			bestaetigung_fa: {
				label: "Bestätigung Finanzamt"
			},
			eigenmittel: {
				label: "Eigenmittel"
			},
			karenzgeldbescheid: {
				label: "Karenzgeldbescheid"
			},
			alimente_zu_zahlen: {
				label: "Alimente zu zahlen"
			},
			alimente_erhalten: {
				label: "erhaltene Alimente"
			},
			sozialversicherungsdatenauszug: {
				label: "Sozialversicherungsdatenauszug"
			},
			dienstvertrag: {
				label: "Dienstvertrag"
			},
			sonstige: {
				label: "Sonstige",
				subfield:
				{
					key: "sonstige",
					label: "Sonstige",
				}
			}
		},
		liegenschaft: {
			grundbuchauszug: {
				label: "Grundbuchauszug",
				description: "Wenn nicht vorhanden brauchen wir zumindest die Daten der Katastralgemeinde (KG) und Einlagezahl (EZ). Diese sind üblicherweise auf dem Plan, einem bestehenden Kreditvertrag oder im Kaufvertrag ersichtlich."
			},
			fotos: {
				label: "Fotos vom Objekt",
				description: <>
					<div>WICHTIG: egal ob Haus oder Wohnung es gelten die selben Parameter:</div>
					<div>– Fotos von außen und innen</div>
					<div>– Außen – 1 Foto von jeder Seite des Objektes</div>
					<div>– evtl wertsteigernde Fotos wie zB Pool, Terrasse, Überdachungen, Carports, Gartenhütten etc</div>
					<div>– Innen – 1 Foto von allen Räumen – WICHTIG Heizung, Sanitärräume, Technickraum, Kachelofen etc</div>
				</>
			},
			plan: {
				label: "Plan",
				description: <>
					<div>Plan vom Objekt: im besten Fall – Einreichplan</div>
					<div>Ansonsten Pläne als eine gesammelte Datei übermitteln.</div>
					<div>Wenn kein Plan vorhanden ist, dann ist einer selbst zu zeichnen und es sind Originalmaße zu nehmen. Auf dem Plan müssen die Raummaße und Flächenmaße deutlich lesbar sein.</div>
				</>
			},
			nutzwertgutachten: {
				label: "Nutzwertgutachten",
			},
			liegenschaftscheckliste: {
				label: "Liegenschaftscheckliste",
			},
			sonstige: {
				label: "Sonstige",
				subfield:
				{
					key: "sonstige",
					label: "Sonstige",
				}
			}
		},
		finanzierung: {
			finanzierungsantrag: {
				label: "Finanzierungsantrag",
				description: "alle Seiten des Dokumenten unterschrieben und in einer PDF Datei zusammengefügt."
			},
			kaufvertrag: {
				label: "Kaufvertrag",
				description: "Grundsätzlich ist ein personalisierter Kaufvertragsentwurf ausreichen, dass bedeutet der Kaufvertrag muss noch nicht unterschrieben sein"
			},
			kaufanbot: {
				label: "Kaufanbot",
			},
			baukostenaufstellung: {
				label: "Baukostenaufstellung",
				description: <>
					<div>Zusammen mit dem Kunden ausfüllen</div>
					<div>Kostenvoranschläge und Angebote wenn vorhanden beilegen</div>
					<div>Summe der Baukosten = benötigter Geldbedarf für den Bau, die Sanierung etc</div>
					<div>Kosten für den Grundkauf NICHT eintragen</div>
				</>
			},
			kostenvoranschlaege: {
				label: "Kostenvoranschläge",
			},
			sonstige: {
				label: "Sonstige",
				subfield:
				{
					key: "sonstige",
					label: "Sonstige",
				}
			}
		},
		vorlast: {
			kreditvertrag: {
				label: "Kreditvertrag",
				description: <>
					<div>alle Seiten des Kreditvertrages um keine versteckten Kosten zu übersehen</div>
					<div>Bedingungen und Allgemeine Informationen sind nicht notwendig</div>
					<div>Hier sind auch Leasingverträge gemeint</div>
				</>
			},
			restsaldobestaetigung: {
				label: "Restsaldobestätigung",
				description: "WICHTIG – immer mit ersichtlichem und aktuellen Datum"
			},
			sonstige: {
				label: "Sonstige",
				subfield:
				{
					key: "sonstige",
					label: "Sonstige",
				}
			}
		},
		signed: {
			sonstige: {
				label: "Sonstige",
				subfield:
				{
					key: "sonstige",
					label: "Sonstige",
				}
			}
		},
	};


	useEffect(() => {
		refreshAvailableFields();
		const newFileGroupsCompleted = {

		};

		if (metafields && metafields.length > 0) {
			const filesCompletedMetafields = metafields.filter(field => field.meta_key.startsWith("files_") && field.meta_key.endsWith("_completed"));
			if (filesCompletedMetafields && filesCompletedMetafields.length > 0) {
				filesCompletedMetafields.forEach(field => {
					newFileGroupsCompleted[field.meta_key] = field.meta_value_boolean;
				});
			}
		}
		setFileGroupsCompleted(newFileGroupsCompleted);
	}, [metafields]);



	const renderFileUploadFieldGroup = (key_prefix, fields_name, num_fields) => {
		const fields = [];
		const filename_postfix = stringToFilename(fields_name)

		let type_suggestions = {};
		if (key_prefix.includes("person"))
			type_suggestions = file_document_type_suggestions["person"];
		else if (key_prefix.includes("liegenschaft"))
			type_suggestions = file_document_type_suggestions["liegenschaft"];
		else if (key_prefix.includes("finanzierung"))
			type_suggestions = file_document_type_suggestions["finanzierung"];
		else if (key_prefix.includes("vorlast"))
			type_suggestions = file_document_type_suggestions["vorlast"];
		else if (key_prefix.includes("signed"))
			type_suggestions = file_document_type_suggestions["signed"];

		let previousFieldIsEmpty = false;
		let fieldIsEmpty = true;

		for (let index = 1; index <= num_fields; index++) {
			const currentMetafields = metafields.filter(field => field.meta_key === (key_prefix + index));
			//const currentMetafields = fieldsByMetaKey[key_prefix + index];
			if (currentMetafields && currentMetafields.length) {
				fieldIsEmpty = !currentMetafields[0].meta_value;
				if ((!previousFieldIsEmpty && !key_prefix.includes("signed")) || !fieldIsEmpty)
					fields.push(<FileUploadField
						filename_postfix={filename_postfix}
						key={index}
						// fieldConfigs={ fieldConfigsByMetaKey["person" + (index+1) + "_ausweis"] }
						setMetafields={setMetafields}
						metafield_prop={currentMetafields[0]}
						type_suggestions={type_suggestions}
						description={(key_prefix.includes("signed") ? "Hier werden Dokumente angezeigt, die im Kundenportal unterzeichnet wurden." : null)}
					/>);
				previousFieldIsEmpty = fieldIsEmpty;
			}
		}
		return (<>{fields}</>);
	}


	const refreshAvailableFields = () => {
		const newAvailableFiles = availableFiles;
		// Gruppen anlegen
		if (!("finanzierung" in newAvailableFiles))
			newAvailableFiles["finanzierung"] = {
				group_name: "Finanzierung",
				key_prefix: "finanzierung_file",
				fields: []
			}

		for (let i = 0; i < 4; i++) {
			if (!("person" + (i + 1) in newAvailableFiles))
				newAvailableFiles["person" + (i + 1)] = {
					group_name: "Kreditnehmer " + (i + 1),
					key_prefix: "person" + (i + 1) + "_file",
					fields: []
				}
		}

		for (let i = 0; i < 3; i++) {
			if (!("liegenschaft" + (i + 1) in newAvailableFiles))
				newAvailableFiles["liegenschaft" + (i + 1)] = {
					group_name: "Liegenschaft " + (i + 1),
					key_prefix: "liegenschaft" + (i + 1) + "_file",
					fields: []
				}
		}

		for (let i = 0; i < 6; i++) {
			if (!("vorlast" + (i + 1) in newAvailableFiles))
				newAvailableFiles["vorlast" + (i + 1)] = {
					group_name: "Vorlast " + (i + 1),
					key_prefix: "vorlast" + (i + 1) + "_file",
					fields: []
				}
		}


		if (!("signed_file" in newAvailableFiles))
			newAvailableFiles["signed_file"] = {
				group_name: "Unterschrift",
				key_prefix: "signed_file",
				fields: []
			}

		Object.keys(newAvailableFiles).map(field_group_key => {

			for (let index = 1; index <= 20; index++) {
				const field_key = newAvailableFiles[field_group_key].key_prefix + index;

				const currentMetafield = metafields.find(field => field.meta_key === field_key);
				if (currentMetafield) {
					const existingIndex = newAvailableFiles[field_group_key].fields.findIndex(field => field.metafield_id === currentMetafield.id);
					if (currentMetafield.meta_value && currentMetafield.file_document_type) {
						const availableFile = {
							metafield_id: currentMetafield.id,
							meta_key: currentMetafield.meta_key,
							filename: currentMetafield.file_document_type,
							file_title: currentMetafield.file_document_type.toUpperCase().replaceAll("_", " "),
							file_field_label: "Datei " + (index + 1)
						};
						if (existingIndex === -1) {
							// add field if not exists
							newAvailableFiles[field_group_key].fields.push(availableFile);
						} else {
							// update if exists
							newAvailableFiles[field_group_key].fields[existingIndex] = availableFile;
						}
					} else if (existingIndex > -1) {
						// remove empty files
						newAvailableFiles[field_group_key].fields.splice(existingIndex, 1);
					}
				}
			}
		})

		console.log(newAvailableFiles);
		setAvailableFiles({ ...newAvailableFiles });

	}





	return (
		<div className={classes.root}>
			<Typography variant="h3">Finanzierung – {credit.title}</Typography>
			<Paper className={classes.descriptionPaper}>
				<Grid container spacing={4}>
					<Grid item xs={12}>
						<Typography variant="h5">Schritt 1: Dokumente hochladen</Typography>
						<Typography>Lade hier erstmal alle Dokumente hoch. Diese kannst du dann in Schritt 2 für die jeweiligen Banken zusammenstellen.</Typography>
					</Grid>
					<Grid item>
						<Button
							size="small"
							startIcon={<ArrowBackIcon />}
							onClick={() => {
								history.push("/finanzierung/" + credit.id);
							}}>
							zurück
						</Button>
					</Grid>
				</Grid>
			</Paper>

			<Accordion TransitionProps={{ unmountOnExit: true }}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography variant="h5">
						Dokumente zur Finanzierung &nbsp;
						{fileGroupsCompleted["files_finanzierung_completed"] && <CheckCircleIcon color="secondary" />}
					</Typography>
				</AccordionSummary>
				<AccordionDetails className={classes.accordionDetailsWithTabs}>
					<Grid container spacing={4} role="tabpanel">
						<Grid item xs={12} align="right">
							<Button
								size="small"
								color="primary"
								download
								target="_blank"
								startIcon={<GetAppIcon />}
								href={`${process.env.REACT_APP_API_SERVICE_URL}/fileuploads/merged/finanzierung/${credit.id}/finanzierung.pdf?token=${userContext.accessToken}`}>
								Alle Finanzierungsdokumente als PDF laden
							</Button>
						</Grid>
						{renderFileUploadFieldGroup("finanzierung_file", "", 20)}
						<Grid item xs={12}>
						</Grid>
						{renderCreditField("files_finanzierung_completed", 12, 12)}
					</Grid>
				</AccordionDetails>
			</Accordion>


			<Accordion TransitionProps={{ unmountOnExit: true }}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography variant="h5">
						Dokumente der Kreditnehmer &nbsp;
						{fileGroupsCompleted["files_person_completed"] && <CheckCircleIcon color="secondary" />}
					</Typography>
				</AccordionSummary>
				<AccordionDetails className={classes.accordionDetailsWithTabs}>
					<AppBar position="static" color="default">
						<Tabs
							value={activeTabPerson}
							indicatorColor="primary"
							textColor="primary"
							onChange={(e, value) => {
								setActiveTabPerson(value);
							}}
						>
							{[0, 1, 2, 3].map(index => {
								const firstname = creditFunctions.getFirstValueByMetaKey("__person" + (index + 1) + "__vorname");
								const lastname = creditFunctions.getFirstValueByMetaKey("__person" + (index + 1) + "__nachname");
								let tabLabel = firstname && lastname ? firstname + " " + lastname : "Kreditnehmer " + (index + 1);
								return (
									<Tab
										label={tabLabel}
										key={index}
										disabled={!firstname || !lastname}
									// icon={
									// 	<CircularProgressWithLabel percent={creditFunctions.getFieldGroupProgress("person", index + 1)} />
									// }
									/>
								)
							})
							}
						</Tabs>
					</AppBar>
					<br />
					{[0, 1, 2, 3].map(index => {
						if (activeTabPerson === index) {
							const firstname = creditFunctions.getFirstValueByMetaKey("__person" + (index + 1) + "__vorname");
							const lastname = creditFunctions.getFirstValueByMetaKey("__person" + (index + 1) + "__nachname");
							if (!firstname || !lastname)
								return (
									<Grid container spacing={4} role="tabpanel" key={index}>
										<Grid item xs={12} align="center">
											<Typography>Bitte füll erst die Daten aus bevor du Dokumente hoch lädst.</Typography>
										</Grid>
									</Grid>
								);
							return (
								<Grid container spacing={4} role="tabpanel" key={index}>
									<Grid item xs={12} align="right">
										<Button
											size="small"
											color="primary"
											download
											target="_blank"
											startIcon={<GetAppIcon />}
											href={`${process.env.REACT_APP_API_SERVICE_URL}/fileuploads/merged/person${(index + 1)}/${credit.id}/${stringToFilename(firstname + " " + lastname)}.pdf?token=${userContext.accessToken}`}>
											Alle Dokumente von {firstname + " " + lastname} als PDF laden
										</Button>
									</Grid>
									{renderFileUploadFieldGroup("person" + (index + 1) + "_file", firstname + " " + lastname, 20)}
								</Grid>
							);
						}
					})
					}
					<Grid container spacing={4} >
						<Grid item xs={12}>
						</Grid>
						{renderCreditField("files_person_completed", 12, 12)}
					</Grid>
				</AccordionDetails>
			</Accordion>
			{credit.type === "hypothekar" &&
				<Accordion TransitionProps={{ unmountOnExit: true }}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
					>
						<Typography variant="h5">
							Dokumente zu Liegenschaften &nbsp;
							{creditFunctions.getFirstValueByMetaKey("files_liegenschaft_completed") && <CheckCircleIcon color="secondary" />}
						</Typography>
					</AccordionSummary>
					<AccordionDetails className={classes.accordionDetailsWithTabs}>
						<AppBar position="static" color="default">
							<Tabs
								value={activeTabLiegenschaft}
								indicatorColor="primary"
								textColor="primary"
								onChange={(e, value) => {
									setActiveTabLiegenschaft(value);
								}}
							>
								{[0, 1, 2].map(index => {
									const objekt = creditFunctions.getFirstValueByMetaKey("objektdaten_liegenschaft" + (index + 1) + "_objekt");
									const ort = creditFunctions.getFirstValueByMetaKey("objektdaten_liegenschaft" + (index + 1) + "_objekt_ort");
									let tabLabel = objekt && ort ? objekt + " " + ort : "Liegenschaft " + (index + 1);
									return (
										<Tab
											label={tabLabel}
											key={index}
											disabled={!objekt || !ort}
										// icon={
										// 	<CircularProgressWithLabel percent={creditFunctions.getFieldGroupProgress("person", index + 1)} />
										// }
										/>
									)
								})
								}
							</Tabs>
						</AppBar>
						<br />
						{[0, 1, 2].map(index => {
							if (activeTabLiegenschaft === index) {
								const objekt = creditFunctions.getFirstValueByMetaKey("objektdaten_liegenschaft" + (index + 1) + "_objekt");
								const ort = creditFunctions.getFirstValueByMetaKey("objektdaten_liegenschaft" + (index + 1) + "_objekt_ort");
								if (!objekt || !ort)
									return (
										<Grid container spacing={4} role="tabpanel" key={index}>
											<Grid item xs={12} align="center">
												<Typography>Bitte füll erst die Daten aus bevor du Dokumente hoch lädst.</Typography>
											</Grid>
										</Grid>
									);
								return (
									<Grid container spacing={4} role="tabpanel" key={index}>
										<Grid item xs={12} align="right">
											<Button
												size="small"
												color="primary"
												download
												target="_blank"
												startIcon={<GetAppIcon />}
												href={`${process.env.REACT_APP_API_SERVICE_URL}/fileuploads/merged/liegenschaft${(index + 1)}/${credit.id}/${stringToFilename(objekt + " " + ort)}.pdf?token=${userContext.accessToken}`}>
												Alle Dokumente dieser Liegenschaft als PDF laden
											</Button>
										</Grid>
										{renderFileUploadFieldGroup("liegenschaft" + (index + 1) + "_file", objekt + " " + ort, 20)}
									</Grid>
								);
							}
						})
						}
						<Grid container spacing={4} >
							<Grid item xs={12}>
							</Grid>
							{renderCreditField("files_liegenschaft_completed", 12, 12)}
						</Grid>
					</AccordionDetails>
				</Accordion>
			}


			<Accordion TransitionProps={{ unmountOnExit: true }}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography variant="h5">
						Dokumente zu Vorlasten &nbsp;
						{fileGroupsCompleted["files_vorlast_completed"] && <CheckCircleIcon color="secondary" />}
					</Typography>
				</AccordionSummary>
				<AccordionDetails className={classes.accordionDetailsWithTabs}>
					<AppBar position="static" color="default">
						<Tabs
							value={activeTabVorlast}
							indicatorColor="primary"
							textColor="primary"
							onChange={(e, value) => {
								setActiveTabVorlast(value);
							}}
						>
							{[0, 1, 2, 3, 4, 5].map(index => {
								const kreditnehmer = creditFunctions.getFirstValueByMetaKey("__vorlast" + (index + 1) + "__kreditnehmer");
								const institut = creditFunctions.getFirstValueByMetaKey("__vorlast" + (index + 1) + "__institut");
								const vorbelastung_fuer = creditFunctions.getFirstValueByMetaKey("__vorlast" + (index + 1) + "__vorbelastung_fuer");
								let tabLabel = kreditnehmer && vorbelastung_fuer && institut ? vorbelastung_fuer.replaceAll("_", " ") + " " + institut : "Vorlast " + (index + 1);
								return (
									<Tab
										label={tabLabel}
										key={index}
										disabled={!kreditnehmer || !vorbelastung_fuer || !institut}
									// icon={
									// 	<CircularProgressWithLabel percent={creditFunctions.getFieldGroupProgress("person", index + 1)} />
									// }
									/>
								)
							})
							}
						</Tabs>
					</AppBar>
					<br />
					{[0, 1, 2, 3, 4, 5].map(index => {
						if (activeTabVorlast === index) {
							const kreditnehmer = creditFunctions.getFirstValueByMetaKey("__vorlast" + (index + 1) + "__kreditnehmer");
							const institut = creditFunctions.getFirstValueByMetaKey("__vorlast" + (index + 1) + "__institut");
							const vorbelastung_fuer = creditFunctions.getFirstValueByMetaKey("__vorlast" + (index + 1) + "__vorbelastung_fuer");

							if (!kreditnehmer || !vorbelastung_fuer || !institut)
								return (
									<Grid container spacing={4} role="tabpanel" key={index}>
										<Grid item xs={12} align="center">
											<Typography>Bitte füll erst die Daten aus bevor du Dokumente hoch lädst.</Typography>
										</Grid>
									</Grid>
								);
							return (
								<Grid container spacing={4} role="tabpanel" key={index}>
									<Grid item xs={12} align="right">
										<Button
											size="small"
											color="primary"
											download
											target="_blank"
											startIcon={<GetAppIcon />}
											href={`${process.env.REACT_APP_API_SERVICE_URL}/fileuploads/merged/vorlast${(index + 1)}/${credit.id}/${stringToFilename(vorbelastung_fuer + " " + institut)}.pdf?token=${userContext.accessToken}`}>
											Alle Dokumente dieser Vorlast als PDF laden
										</Button>
									</Grid>
									{renderFileUploadFieldGroup("vorlast" + (index + 1) + "_file", vorbelastung_fuer + " " + institut, 20)}
								</Grid>
							);
						}
					})
					}
					<Grid container spacing={4} >
						<Grid item xs={12}>
						</Grid>
						{renderCreditField("files_vorlast_completed", 12, 12)}
					</Grid>
				</AccordionDetails>
			</Accordion>

			<Accordion TransitionProps={{ unmountOnExit: true }}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography variant="h5">
						Unterschriebene Dokumente &nbsp;
						{fileGroupsCompleted["files_signed_completed"] && <CheckCircleIcon color="secondary" />}
					</Typography>
				</AccordionSummary>
				<AccordionDetails className={classes.accordionDetailsWithTabs}>
					<Grid container spacing={4} role="tabpanel">
						<Grid item xs={12} align="right">
							<Button
								size="small"
								color="primary"
								download
								target="_blank"
								startIcon={<GetAppIcon />}
								href={`${process.env.REACT_APP_API_SERVICE_URL}/fileuploads/merged/signed/${credit.id}/unterschriften.pdf?token=${userContext.accessToken}`}>
								Alle unterschriebenen Dokumente als PDF laden
							</Button>
						</Grid>
						{renderFileUploadFieldGroup("signed_file", "", 30)}
						<Grid item xs={12}>
						</Grid>
						{renderCreditField("files_signed_completed", 12, 12)}
					</Grid>
				</AccordionDetails>
			</Accordion>

			<br /><br /><br />
			{credit.type === "hypothekar" &&
				<Paper className={classes.descriptionPaper}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<Typography variant="h5">Schritt 2: Einstellungen für die Übertragung</Typography>
							<Typography>Pro Bank kannst du die Dokumente jetzt passend zusammenstellen und dann senden.</Typography>
							{/* <Button
							size="small"
							startIcon={<SyncIcon />}
							onClick={() => {
								refreshAvailableFields();
							}}>
							verfügbare Dokumente aktualisieren
						</Button> */}
						</Grid>
					</Grid>
				</Paper>
			}
			{channels.map((channel) => {
				if (channel.channel_shortname === "BAWAG" && channel.enabled) {
					const currentMetafield = metafields.find(field =>
						field.meta_key === "file_submission_settings" && field.channel === channel.channel_shortname
					);
					if (currentMetafield) {
						return <CreditFilesBawag
							channel={channel}
							availableFiles={availableFiles}
							key={"filesettings-" + channel.channel_shortname}
							credit_id={credit.id}
							metafield={currentMetafield}
						/>;
					}
				}
				if (channel.channel_shortname === "START" && channel.enabled) {
					const currentMetafield = metafields.find(field =>
						field.meta_key === "file_submission_settings" && field.channel === channel.channel_shortname
					);
					if (currentMetafield) {
						return <CreditFilesStart
							channel={channel}
							availableFiles={availableFiles}
							key={"filesettings-" + channel.channel_shortname}
							credit_id={credit.id}
							metafield={currentMetafield}
						/>;
					}
				}
				if (channel.channel_shortname === "BANKAUSTRIA" && channel.enabled) {
					const currentMetafield = metafields.find(field =>
						field.meta_key === "file_submission_settings" && field.channel === channel.channel_shortname
					);
					if (currentMetafield) {
						return <CreditFilesBankAustria
							channel={channel}
							availableFiles={availableFiles}
							key={"filesettings-" + channel.channel_shortname}
							credit_id={credit.id}
							metafield={currentMetafield}
						/>;
					}
				}
				return null;
			})}

		</div>
	);
}
